module.exports = __webpack_public_path__ + "img/info.a814c359.svg";